var map = {
	"./App": [
		"M93x"
	],
	"./App.vue": [
		"M93x"
	],
	"./assets/css/magnifier.css": [
		"gJP/",
		4
	],
	"./assets/css/main.css": [
		"CuRo",
		2
	],
	"./assets/css/mainB.css": [
		"Hzte",
		1
	],
	"./assets/images/admin-icon.svg": [
		"R0tV",
		56
	],
	"./assets/images/analytics-icon.svg": [
		"gaDJ",
		55
	],
	"./assets/images/analyticsboard.svg": [
		"rR+j"
	],
	"./assets/images/android.svg": [
		"LuwU",
		54
	],
	"./assets/images/app-store.svg": [
		"M5fD",
		53
	],
	"./assets/images/backend.svg": [
		"NBJa",
		52
	],
	"./assets/images/backendwhite.svg": [
		"8hai"
	],
	"./assets/images/banner-gfx-blue.svg": [
		"/mfR",
		51
	],
	"./assets/images/banner-gfx.svg": [
		"Z1fh",
		50
	],
	"./assets/images/banner-slide.svg": [
		"gTfg",
		49
	],
	"./assets/images/casual-dark-large.jpg": [
		"qa5M",
		48
	],
	"./assets/images/casual-dark.png": [
		"+kF5",
		47
	],
	"./assets/images/casual-light-large.jpg": [
		"6wVn",
		46
	],
	"./assets/images/casual-light.png": [
		"OXBq"
	],
	"./assets/images/clientapps.svg": [
		"m8ch"
	],
	"./assets/images/cross.svg": [
		"VC5H",
		45
	],
	"./assets/images/dashboard-slide (copy).svg": [
		"YxAv",
		44
	],
	"./assets/images/dashboard-slide.svg": [
		"9ms9",
		43
	],
	"./assets/images/gfx-blue.svg": [
		"UMYF",
		42
	],
	"./assets/images/gfx-bot-blue.svg": [
		"zn3l",
		41
	],
	"./assets/images/gfx-bot.svg": [
		"ExfC"
	],
	"./assets/images/gfx-dash-bot-blue.svg": [
		"MUfx",
		40
	],
	"./assets/images/gfx-dash-bot.svg": [
		"cj/f",
		39
	],
	"./assets/images/gfx-dash-mid-blue.svg": [
		"/YaY",
		38
	],
	"./assets/images/gfx-dash-mid.svg": [
		"AxnV",
		37
	],
	"./assets/images/gfx-f-bot-blue.svg": [
		"Xp4J",
		36
	],
	"./assets/images/gfx-f-bot.svg": [
		"FKnI",
		35
	],
	"./assets/images/gfx-small-blue.svg": [
		"u7CD",
		34
	],
	"./assets/images/gfx-small.svg": [
		"Dz47",
		33
	],
	"./assets/images/gfx.svg": [
		"+4o1",
		32
	],
	"./assets/images/gfx4-blue.svg": [
		"bwk1",
		31
	],
	"./assets/images/gfx4.svg": [
		"JHgH",
		30
	],
	"./assets/images/icons/VOD.svg": [
		"/wxl",
		29
	],
	"./assets/images/icons/admin-icon.svg": [
		"NIt2"
	],
	"./assets/images/icons/analytics-icon.svg": [
		"NMNL"
	],
	"./assets/images/icons/drm.svg": [
		"N13/"
	],
	"./assets/images/icons/drm_security.svg": [
		"ATNA",
		28
	],
	"./assets/images/icons/instant-icon.svg": [
		"mOkF"
	],
	"./assets/images/icons/livevideo.svg": [
		"UuJc"
	],
	"./assets/images/icons/modes-icon.svg": [
		"Oppg"
	],
	"./assets/images/icons/monetization.svg": [
		"OOdf"
	],
	"./assets/images/icons/notifications-icon.svg": [
		"V0ik"
	],
	"./assets/images/icons/reliable-icon.svg": [
		"bb4/",
		27
	],
	"./assets/images/icons/social-icon.svg": [
		"YzmF"
	],
	"./assets/images/icons/streaming-icon.svg": [
		"aGEH"
	],
	"./assets/images/instant-icon.svg": [
		"Ca5k",
		26
	],
	"./assets/images/knowdiabetes.png": [
		"0XWP"
	],
	"./assets/images/lattu-logo.png": [
		"LFdq"
	],
	"./assets/images/loader.gif": [
		"x4IX",
		25
	],
	"./assets/images/loader1.gif": [
		"OlGi",
		24
	],
	"./assets/images/loading.gif": [
		"F7NO",
		23
	],
	"./assets/images/logo_white.svg": [
		"vX6J"
	],
	"./assets/images/mobiotics-logo-horizontal.svg": [
		"/krl"
	],
	"./assets/images/modern-dark-large.jpg": [
		"mTID",
		22
	],
	"./assets/images/modern-dark.png": [
		"7uIX",
		21
	],
	"./assets/images/modern-dark_bak.png": [
		"2s4t",
		20
	],
	"./assets/images/modern-light-large.jpg": [
		"cOLk",
		19
	],
	"./assets/images/modern-light.png": [
		"woOV"
	],
	"./assets/images/modern-light_bak.png": [
		"ScJP",
		18
	],
	"./assets/images/modes-icon.svg": [
		"p0YP",
		17
	],
	"./assets/images/notifications-icon.svg": [
		"Wx6j",
		16
	],
	"./assets/images/purple_slide.svg": [
		"/cgy",
		15
	],
	"./assets/images/purple_slide1.svg": [
		"gWYq",
		14
	],
	"./assets/images/reliable-icon.svg": [
		"F3br",
		13
	],
	"./assets/images/sampleimage.svg": [
		"HgLU",
		12
	],
	"./assets/images/social-icon.svg": [
		"3UzA",
		11
	],
	"./assets/images/streaming-icon.svg": [
		"/74Y",
		10
	],
	"./assets/images/tick-blue.svg": [
		"bYXl",
		9
	],
	"./assets/images/tick.svg": [
		"hQsS",
		8
	],
	"./assets/images/v-lite-white-logo.svg": [
		"aUqx"
	],
	"./assets/images/vLiteLogo.png": [
		"zxL4",
		7
	],
	"./assets/images/vlive.png": [
		"MiBM"
	],
	"./assets/images/vlive@2x.png": [
		"ZDQv",
		6
	],
	"./assets/images/vlive@3x.png": [
		"c+KN",
		5
	],
	"./assets/js/Event": [
		"nHYM"
	],
	"./assets/js/Event.js": [
		"nHYM"
	],
	"./assets/js/Magnifier": [
		"VL+T"
	],
	"./assets/js/Magnifier.js": [
		"VL+T"
	],
	"./assets/js/config": [
		"vgQg"
	],
	"./assets/js/config.js": [
		"vgQg"
	],
	"./assets/js/helpers": [
		"2pwR",
		0
	],
	"./assets/js/helpers.js": [
		"2pwR",
		0
	],
	"./components/Dashboard": [
		"TGvd"
	],
	"./components/Dashboard.vue": [
		"TGvd"
	],
	"./components/Democonfirm": [
		"6MUd"
	],
	"./components/Democonfirm.vue": [
		"6MUd"
	],
	"./components/Emailverify": [
		"KCOl"
	],
	"./components/Emailverify.vue": [
		"KCOl"
	],
	"./components/Failed": [
		"zweM"
	],
	"./components/Failed.vue": [
		"zweM"
	],
	"./components/HelloWorld": [
		"gORT"
	],
	"./components/HelloWorld.vue": [
		"gORT"
	],
	"./components/Home": [
		"lO7g"
	],
	"./components/Home.vue": [
		"lO7g"
	],
	"./components/Reqdemo": [
		"JIAy"
	],
	"./components/Reqdemo.vue": [
		"JIAy"
	],
	"./components/Success": [
		"2KHa"
	],
	"./components/Success.vue": [
		"2KHa"
	],
	"./components/Test": [
		"ua3t"
	],
	"./components/Test.vue": [
		"ua3t"
	],
	"./main": [
		"NHnr"
	],
	"./main.js": [
		"NHnr"
	],
	"./router": [
		"YaEn"
	],
	"./router/": [
		"YaEn"
	],
	"./router/index": [
		"YaEn"
	],
	"./router/index.js": [
		"YaEn"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5Q+W";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy ^.*$
// module id = 5Q+W
// module chunks = 58